import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { useTranslation } from "react-i18next";
import dateFormat from "dateformat";
import { Empty, Spin } from "antd";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import "./styles.scss";

// backend holat rangi -> pill klassi
const STATUS_CLASS = {
  success: "ok",
  primary: "info",
  info: "info",
  warning: "warn",
  orange: "warn",
  danger: "danger",
  red: "danger",
};

const Field = ({ label, value, wide }) =>
  value ? (
    <div className={wide ? "ap-field ap-field--wide" : "ap-field"}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  ) : null;

const Section = ({ icon, title, children }) => (
  <section className="ap-card">
    <h3 className="ap-card__title">
      <i className={`bx ${icon}`} />
      {title}
    </h3>
    <dl className="ap-grid">{children}</dl>
  </section>
);

const DownloadBtn = ({ href, children }) => (
  <a className="ln-btn ln-btn_primary ap-download" href={href} target="_blank" rel="noopener noreferrer">
    <i className="bx bx-download" />
    {children}
  </a>
);

function ShowApplic(props) {
  const { t } = useTranslation();
  const [datas, setDatas] = useState();
  const lan = useSelector((state) => state.langReducer);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  useEffect(() => {
    axios
      .get(url.url + `/application/${props.id}`, { headers: headers() })
      .then((res) => {
        setDatas(res.data.data);
      })
      .catch((err) => {
        if (err.response?.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response?.status == 404) window.location = "/404";
        if (err.response?.status == 405) toast.error(err.response.data.error);
      });
  }, [lan]);

  if (!datas)
    return (
      <div className="ap-loading">
        <Loader />
      </div>
    );

  const drug = datas.drug || {};
  const rep = datas.representative || {};
  const statusCls = STATUS_CLASS[datas.status?.color] || "mute";

  return (
    <div className="ap">
      {/* xulosa */}
      <section className="ap-summary">
        <div className="ap-summary__main">
          <span className="ap-summary__code">
            {t("Code")} № {datas.code}
          </span>
          <h2 className="ap-summary__title">{drug.name || "—"}</h2>
          {drug.trade_name && drug.trade_name !== drug.name ? (
            <span className="ap-summary__sub">{drug.trade_name}</span>
          ) : (
            ""
          )}
          <div className="ap-summary__pills">
            <span className={`ap-pill ap-pill--${statusCls}`}>{datas.status?.name}</span>
            <span className={`ap-pill ap-pill--${datas.is_paid == 1 ? "ok" : "mute"}`}>
              <i className={`bx ${datas.is_paid == 1 ? "bx-check" : "bx-wallet"}`} />
              {datas.is_paid == 1 ? t("paid") : t("unpaid")}
            </span>
          </div>
        </div>

        <dl className="ap-summary__facts">
          <div>
            <dt>{t("Stage")}</dt>
            <dd>{datas.stage?.name || "—"}</dd>
          </div>
          <div>
            <dt>{t("Date")}</dt>
            <dd>{datas.created_at ? dateFormat(datas.created_at, "dd.mm.yyyy") : "—"}</dd>
          </div>
          <div>
            <dt>{t("Sertificat")}</dt>
            <dd>
              {datas.certificate?.file ? (
                <DownloadBtn href={datas.certificate.file}>
                  {datas.certificate.number || t("Download")}
                </DownloadBtn>
              ) : (
                <span className="ap-muted">—</span>
              )}
            </dd>
          </div>
          {datas.is_canceled && datas.cancel?.file ? (
            <div>
              <dt>{t("cancel")}</dt>
              <dd>
                <DownloadBtn href={datas.cancel.file}>{t("Download")}</DownloadBtn>
              </dd>
            </div>
          ) : (
            ""
          )}
          {datas.return?.file ? (
            <div>
              <dt>{t("Status")}</dt>
              <dd>
                <DownloadBtn href={datas.return.file}>{t("Download")}</DownloadBtn>
              </dd>
            </div>
          ) : (
            ""
          )}
        </dl>
      </section>

      <Section icon="bx-buildings" title={t("Applicant_Information")}>
        <Field label={t("Applicant")} value={datas.applicant} wide />
        <Field label={t("Representative of the applicant")} value={rep.name} wide />
        <Field label={t("Address")} value={rep.address} wide />
        <Field label={t("Phone number")} value={rep.phone} />
        <Field label={t("Fax address")} value={rep.fax} />
      </Section>

      <Section icon="bx-capsule" title={t("Drug Information")}>
        <Field label={t("Drug")} value={drug.name} />
        <Field label={t("Trade name")} value={drug.trade_name} />
        <Field label={t("Drug form")} value={drug.drug_figure?.name} />
        <Field label={t("Country")} value={drug.country?.name} />
        <Field label={t("Patent")} value={drug.patent} />
        <Field label={t("Content")} value={drug.structure} wide />
        <Field label={t("Applicat")} value={drug.usage} wide />
      </Section>

      <div className="ap-pair">
        <Section icon="bx-package" title={t("Preparer")}>
          <Field label={t("Preparer")} value={drug.preparer?.name} wide />
          <Field label={t("Address")} value={drug.preparer?.address} wide />
          <Field label={t("Country")} value={drug.preparer?.country?.name} />
          <Field label={t("Phone number")} value={drug.preparer?.phone} />
          <Field label={t("Fax address")} value={drug.preparer?.fax} />
        </Section>
        <Section icon="bx-factory" title={t("Manufacturer")}>
          <Field label={t("Manufacturer")} value={drug.manufacturer?.name} wide />
          <Field label={t("Address")} value={drug.manufacturer?.address} wide />
          <Field label={t("Country")} value={drug.manufacturer?.country?.name} />
          <Field label={t("Phone number")} value={drug.manufacturer?.phone} />
          <Field label={t("Fax address")} value={drug.manufacturer?.fax} />
        </Section>
      </div>
    </div>
  );
}

export default ShowApplic;
